import { render, staticRenderFns } from "./exerciseList.vue?vue&type=template&id=0ed5d0fb&scoped=true"
import script from "./exerciseList.vue?vue&type=script&lang=js"
export * from "./exerciseList.vue?vue&type=script&lang=js"
import style0 from "./exerciseList.vue?vue&type=style&index=0&id=0ed5d0fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed5d0fb",
  null
  
)

export default component.exports